import { FileUpload } from "./file-upload";

export interface SupportCategory {
  key: string;
  name: string;
  subCategories: SubCategory[];
}
export interface SubCategory {
  key: string;
  label: string;
  text: string;
}

export interface SupportInput {
  email?: string;
  message?: string;
  title?: string;
  passport?: FileUpload;
  personalPhoto?: FileUpload;
  iban?: string;
  bankName?: string;
  swiftCode?: string;
  branchName?: string;
  bankAddress?: string;
  accountHolderName?: string;
  newPhoneNumber?: string;
  swift?: FileUpload;
  street?: string;
  city?: string;
  postalCode?: string;
  country?: string;
  area?: string;
  proofOfAddressDocument?: FileUpload;
  screenshot?: FileUpload;
  newEmailAddress?: string;
  documents?: FileUpload[];
  accountNumber?: string;
}
export interface EscalationInput {
  email: string ;
  ticketID: number ;
  description: string ;
  escalationType: EscalationType ;
}
export enum TicketType {
  Document,
  UnknownIssue,
  Deposit,
  Name,
  Other,
}
export interface FileInput {
  base64: string;
  file: File;
}

export enum EscalationType {
  COMPLIANCE_AND_VERIFICATION_CONCERNS = 'COMPLIANCE_AND_VERIFICATION_CONCERNS',
  SECURITY_AND_UNAUTHORIZED_ACCESS = 'SECURITY_AND_UNAUTHORIZED_ACCESS',
  FIAT_DEPOSIT_AND_WITHDRAWAL_PROBLEMS = 'FIAT_DEPOSIT_AND_WITHDRAWAL_PROBLEMS',
  TRADING_AND_TRANSACTION_ISSUES = 'TRADING_AND_TRANSACTION_ISSUES',
  CRYPTO_DEPOSITS_AND_WITHDRAWALS_PROBLEMS = 'CRYPTO_DEPOSITS_AND_WITHDRAWALS_PROBLEMS',
  THIRD_PARTY_AND_PARTNER_SERVICE_ISSUES = 'THIRD_PARTY_AND_PARTNER_SERVICE_ISSUES',
  PLATFORM_AND_SERVICE_DOWNTIME = 'PLATFORM_AND_SERVICE_DOWNTIME',
  CUSTOMER_EXPERIENCE_AND_SUPPORT_QUALITY = 'CUSTOMER_EXPERIENCE_AND_SUPPORT_QUALITY',
  WALLET_AND_ACCOUNT_DISCREPANCIES = 'WALLET_AND_ACCOUNT_DISCREPANCIES',
}
